import React from 'react';
import { Box, Typography } from '@mui/material';
import { AttachFile, FlagOutlined, Undo } from '@mui/icons-material';
import { usePatientMatchedProvider, useUserQuery } from '@uplift/queries';
import { Match } from '@uplift/api';
import { BaseActivityItem } from '../BaseActivityItem';
import { VolunteerActivismIcon } from '@uplift/icons';


export type RematchActivityItemProps = {
  match: Match;
  onActivityClick?: () => void;
};


export const RematchActivityItem: React.FC<RematchActivityItemProps> = (props) => {
  const { data: patient } = useUserQuery(props.match.patientId);

  return (
    <BaseActivityItem title="Rematch" color="secondary" icon={Undo}>
      <Typography color="textSecondary">{patient?.firstName} has opted to change providers.</Typography>
    </BaseActivityItem>
  );
};

export const NewMatchByAdminActivityItem: React.FC<RematchActivityItemProps> = (props) => {
  const { data: patient } = useUserQuery(props.match.patientId);
  const { data: provider } = usePatientMatchedProvider(props.match.patientId, props.match?.providerId);

  return (
    <BaseActivityItem title="New Provider" color="secondary" icon={FlagOutlined}>
      <Typography color="textSecondary">{provider?.overview?.displayName} has been added to {patient?.firstName}’s Care Team.</Typography>
    </BaseActivityItem>
  );
};

export const NewMatchByReferralActivityItem: React.FC<RematchActivityItemProps> = (props) => {
  const { data: patient } = useUserQuery(props.match.patientId);
  const { data: provider } = usePatientMatchedProvider(props.match.patientId, props.match?.providerId);
  const { data: referredByProvider } = usePatientMatchedProvider(props.match.patientId, props.match?.createdBy);
  const subtitle = `by ${referredByProvider?.user?.firstName[0]}. ${referredByProvider?.user?.lastName}`;

  return (
    <BaseActivityItem
      onClick={props.onActivityClick}
      title={<Typography>Psychiatry Referral</Typography>}
      icon={VolunteerActivismIcon}
      color="secondary"
      rightContent={(
        <Typography variant="body2" color="textPrimary" data-testid="referral-from-student-school">
          {subtitle}
        </Typography>
      )}
      testId="partner-referral-activity-item"
    >
      <Typography color="textSecondary">{referredByProvider?.overview?.displayName} referred {patient?.firstName} to {provider?.overview?.displayName}.</Typography>
      {props.match.psychReferralNote && (
        <Box display="flex" alignItems="center" gap="4px" data-testid="referral-note-attached">
          <AttachFile style={{ fontSize: '16px', color: '#757575' }} />
          <Typography color="textSecondary" data-testid="referral-note-from">
            Referral Note
          </Typography>
        </Box>
      )}

    </BaseActivityItem>
  );
};


export const NewMatchByRematchActivityItem: React.FC<RematchActivityItemProps> = (props) => {
  const { data: patient } = useUserQuery(props.match.patientId);
  const { data: provider } = usePatientMatchedProvider(props.match.patientId, props.match?.providerId);

  return (
    <BaseActivityItem title="New Provider" color="secondary" icon={FlagOutlined}>
      <Typography color="textSecondary">{patient?.firstName} scheduled a session with {provider?.overview?.displayName}</Typography>
    </BaseActivityItem>
  );
};
